module.exports = __webpack_public_path__ + "static_portal/img/filter.ec971ad8.svg";